

import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import XAddress from 'vux/src/components/x-address/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import { post, fetch, doRequest, toastMsg } from './api/http'

export default {
components: {
XAddress,
XDialog
}
}

Vue.use(VueResource);
Vue.config.productionTip = false
Vue.prototype.$post = post;
Vue.prototype.$get = fetch;
Vue.prototype.$doRequest = doRequest;

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js